import React from 'react';
import $ from '../../../common/AjaxRequest';
import { Modal, Button, Input, Icon, message, Select } from 'antd';
import SearchSelect from '../../common/SearchSelect';
import API_URL from '../../../common/url';
import '../style.less';
import SearchRetrieve from '../../common/SearchRetrieve.new';

class AddSSUMember extends React.Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        hospitalOptions: [],
        memberOptions: [],
        searchParams: {},
        showList: [],
        CourtyardAreaList: [],
        needCourtyardArea: false, //院区必填判断
    };

    // 防抖定时器
    timer = null

    show = () => {
        this.setState({
            visible: true,
        });
    };

    hide = () => {
        this.setState({
            visible: false,
            showList: [],
            hospitalOptions: [],
            memberOptions: [],
            searchParams: {},
            CourtyardAreaList: [],
            needCourtyardArea: false, 
        });
    };


    hospitalSelectChange = value => {
        const { searchParams } = this.state;
        if (value) {
            searchParams.hospitalMainId = value.value;
            searchParams.hospitalMainName = value.text;
            searchParams.courtyardArea = undefined;
        } else {
            searchParams.hospitalMainId = '';
            searchParams.hospitalMainName = '';
        }
        this.setState({ searchParams },() => this.queryCourtyardAreaList());
    }

    queryCourtyardAreaList = () => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            const { searchParams: { hospitalMainId } } = this.state;
            if (hospitalMainId) {
                const options = {
                    method: 'POST',
                    url: API_URL.hospital.queryHospitalCourtyardAreaList,
                    data: {    
                        hospitalMainId,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        const { datas } = res;
                        const {searchParams} = this.state;
                        let needCourtyardArea = false;
                        datas.map(i=>{
                            if (i.courtyardArea) {
                                needCourtyardArea = true;
                            }
                        })
                        searchParams.hospitalId = datas[0].hospitalId;
                        this.setState({ CourtyardAreaList: datas, needCourtyardArea });
                    }
                };
                $.sendRequest(options);
            }
        }, 300);
    }

    memberSelectChange = value => {
        const { searchParams } = this.state;
        if (!value) {
            searchParams.userId = '';
        }
        if (value.label) {
            searchParams.userId = value.key;
        } else {
            searchParams.userId = '';
        }
        this.setState({ searchParams });
    }

    parseHospitalData = (res, value) => {
        if (res.datas) {
            const sourceData = res.datas;
            const data = sourceData.map(item => ({
                text: `${item.hospitalName}`,
                value: item.hospitalId,
            }));
            this.setState({ hospitalOptions: data });
        } else {
            this.setState({ hospitalOptions: [] });
        }
    }

    parseMemberData = (res, value) => {
        if (res.userList) {
            const sourceData = res.userList;
            const data = sourceData.map(item => ({
                text: `${item.name}(${item.employeeCode})`,
                value: item.userId,
            }));
            this.setState({ memberOptions: data });
        } else {
            this.setState({ memberOptions: [] });
        }
    }

    // 点击添加负责医院
    AddResponseHospital = () => {
        const { searchParams, showList, CourtyardAreaList, needCourtyardArea } = this.state;
        const { hospitalMainId, hospitalMainName, courtyardArea, hospitalId } = searchParams;
        if (!hospitalMainId) {
            message.warning('请选择要添加的负责医院');
            return;
        }
        if (hospitalMainId && (!hospitalMainName)) {
            message.warning('请正确选择所要添加的负责医院');
            return;
        }

        const selectItem = hospitalMainId;
        const findVal = showList.findIndex((item) => {
            return item.key == selectItem;
        });
        if (findVal == -1) {
            if(needCourtyardArea && !courtyardArea){
                CourtyardAreaList.map( i =>{
                    showList.push(
                        {
                            value: `${hospitalMainName}${i.courtyardArea}`,
                            key: i.hospitalId,
                        },
                    );
                }
                )
            }else if(needCourtyardArea && courtyardArea){
                showList.push(
                    {
                        value: `${hospitalMainName}${courtyardArea}`,
                        key: hospitalId,
                    },
                );
            }else{
                showList.push(
                    {
                        value: `${hospitalMainName}`,
                        key: hospitalId,
                    },
                );
            }
            this.setState({ showList })
        } else {
            message.error('不能添加重复医院');
        }

    }

    addSSUmember = () => {
        const { searchParams, showList } = this.state;
        const { userId } = searchParams;
        this.setState({ loading: true });
        if (!userId) {
            message.error('请选择人员');
            return;
        }
        if (showList.length == 0) {
            message.error('请选择并添加负责医院');
            return;
        }
        const array = [];
        showList.map(item => {
            array.push(item.key);
        });
        const hospitalIds = array.join(',');
        const options = {
            method: 'POST',
            url: API_URL.hospital.addSsuMember,
            data: {
                hospitalIds,
                userId,
            },
            dataType: 'json',
            doneResult: data => {
                if (!data.error) {
                    this.setState({
                        loading: false,
                    });
                    message.success(
                        '添加SSU成员成功'
                    );
                    this.props.loadData();
                    this.hide();
                }
            }
        }
        $.sendRequest(options)
    };

    getDataList = () => {
        const { showList = [] } = this.state;
        return showList.map(item =>
            (<div className="showHospital"><p key={item.key}>{item.value}<Icon onClick={() => { this.deleteChooseHospital(item); }}
                type="close-circle-o" /></p>
            </div>));
    }

    // 删除选择负责医院
    deleteChooseHospital = (index) => {
        const arr = this.state.showList;
        arr.splice(arr.findIndex(
            item => item.key === index.key), 1);
        this.setState({
            showList: arr,
        });
    }

    courtyardAreaSelectChange = (value) => {
        const { searchParams } = this.state;
        searchParams.hospitalId = value.value;
        searchParams.courtyardArea = value.text;
        this.setState({ searchParams })
    }

    render() {
        const { visible, loading, searchParams = {} } = this.state;
        const { userId, courtyardArea, hospitalMainId, hospitalMainName } = searchParams;
        const { hospitalOptions, memberOptions, CourtyardAreaList, needCourtyardArea } = this.state;
        return (
            <div>
                <Modal
                    title="添加SSU成员"
                    visible={visible}
                    onCancel={this.hide}
                    className="preview-modal inv-detail"
                    wrapClassName="vertical-center-modal"
                    width="500px"
                    footer={[
                        <Button key="back" type="ghost" size="large" onClick={this.hide}>取消</Button>,
                        <Button type="primary" size="large" onClick={this.addSSUmember}>确定</Button>
                    ]}
                >
                    <div>
                        <div className="ChooseMember" >
                            <label className="ui-label">选择人员：</label>
                            {
                                visible &&
                                <SearchSelect
                                    style={{ width: 250 }}
                                    url={API_URL.hospital.queryMemberForAdd}
                                    searchKey='userNameCode'
                                    sourceData={memberOptions}
                                    parserData={this.parseMemberData}
                                    watchValue={this.memberSelectChange}
                                    handleSelect={this.memberSelectChange}
                                    ref={el => { this.hideRef = el; }}
                                    placeholder={'请输入人员姓名或工号'}
                                    className='invsearchselect w-164-select'
                                />
                            }
                        </div>


                        <div className="ResponseHospital">
                            <label className="ui-label">负责医院：</label>

                            {userId ?
                                <SearchRetrieve
                                    keyword="hospitalName"
                                    style={{ width: 250 }}
                                    placeholder="输入医院名称检索"
                                    value={hospitalMainName}
                                    url={API_URL.hospital.queryHospitalForAdd}
                                    config={{ id: 'hospitalMainId', name: 'hospitalName'}}
                                    onChange={value => this.hospitalSelectChange(value)}
                                />
                                :
                                <Input placeholder={'请输入医院名称'} disabled={true} style={{ width: 250 }} />
                            }
                        </div>

                        <div className="ResponseHospital">
                            <label className="ui-label">负责院区：</label>
                                <SearchRetrieve
                                    keyword="hospitalName"
                                    style={{ width: 250 }}
                                    placeholder="输入院区名称检索"
                                    disabled={ !needCourtyardArea || !hospitalMainId }
                                    value={courtyardArea}
                                    params={{ hospitalMainId}}
                                    url={API_URL.hospital.queryHospitalCourtyardAreaList}
                                    config={{ id: 'hospitalId', name: 'courtyardArea'}}
                                    onChange={value => this.courtyardAreaSelectChange(value)}
                                />

                                <Icon
                                onClick={this.AddResponseHospital}
                                type="plus-circle-o"
                                style={{
                                    fontSize: 20,
                                    width: '20px',
                                    position: 'relative',
                                    color: '#181818',
                                    marginLeft: "10px",
                                    top: '3px',
                                }}
                                />                    
                        </div>
                        <div className="showHospitalist" >
                            {this.getDataList()}
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default AddSSUMember;



// WEBPACK FOOTER //
// ./src/components/hospital/ssu/AddSSUMember.js